import { useQuery } from 'react-query';

import { getProgramGeneralHierarchyList as queryFn } from 'api/endPoints/getProgramGeneralHierarchyList';

import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

export const useQueryGetGeneralHierarchyList = () => {
    return useQuery<ProjectTreeNode, QueryError>(['getGeneralHierarchyList'], () => queryFn());
};
